
export default {
    list: [],
    request: null
}